import "./Welcome.css";
import Background from "./Background";
import GliaTech from "../assets/Logo_colored.webp";
import { ReactComponent as Download } from "../assets/download.svg";
import { useEffect, useState } from "react";
import Register from "./Register";
import Login from "./Login";
import { useAuthContext } from "../firebase/AuthContext";
import { storage } from "../firebase/firebaseConfig";
import { ref, getDownloadURL } from "firebase/storage";
import { useIsMobile } from "../hooks/useIsMobile";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

function Welcome() {
  const { user, userData, userLanguage, loading } = useAuthContext();
  const [logoAnim, setLogoAnim] = useState(0);
  const [animFinished, setAnimFinished] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [y, setY] = useState(0);
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  const oobCode = urlParams.get("oobCode");
  const mode = urlParams.get("mode");

  const isElectron = () => {
    return navigator.userAgent.toLowerCase().includes("electron");
  };

  useEffect(() => {
    const fetchFileUrl = async () => {
      try {
        const fileRef = ref(storage, "GliaTechInstaller.exe");
        const url = await getDownloadURL(fileRef);
        setFileUrl(url);
      } catch (error) {
        console.error("Fehler beim Abrufen der Datei-URL:", error);
      }
    };

    if (user && !isElectron() && navigator.userAgent.includes("Windows")) {
      fetchFileUrl();
    }
  }, []);

  useEffect(() => {
    if (mode === "resetPassword" && oobCode) {
      navigate(`/resetPassword?oobCode=${oobCode}`, { replace: true });
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLogoAnim(1);
      setTimeout(() => {
        setAnimFinished(true);
      }, 2000);
    }, 500);
  }, []);

  useEffect(() => {
    if (!loading && animFinished) {
      setY(1);
    }
  }, [loading, animFinished]);

  const texts = {
    de: {
      welcomeBack: "Willkommen zurück",
      dataBeingLoaded: "Daten werden geladen...",
    },
    en: {
      welcomeBack: "Welcome back",
      dataBeingLoaded: "Data is loading...",
    },
  };

  return (
    <>
      <Background />
      <Footer />
      <div className="welcome-list">
        <div
          className="list-item"
          style={{ transform: `translateY(-${y * 100}%)` }}
        >
          <div className="welcome">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <p
                style={{
                  fontSize: isMobile ? "50px" : "200px",
                  margin: "0px",
                  fontWeight: "light",
                  fontFamily:
                    "Consolas, 'Courier New', Courier, Monaco, monospace",
                  color: "white",
                  textShadow: "0px 0px 35px purple",
                  transform:
                    logoAnim == 0
                      ? isMobile
                        ? "translateX(160px)"
                        : "translateX(570px)"
                      : isMobile
                      ? "translateX(-40px)"
                      : "translateX(-60px)",
                  transition: "transform 2s",
                }}
              >
                Glia
              </p>

              <img
                src={GliaTech}
                style={{
                  height: isMobile ? "60px" : "120px",
                  transform: logoAnim == 1 && "rotateZ(720deg)",
                  transition: "transform 2s",
                  position: "absolute",
                }}
              ></img>
              <p
                style={{
                  fontSize: isMobile ? "50px" : "200px",
                  margin: "0px",
                  fontWeight: "light",
                  fontFamily:
                    "Consolas, 'Courier New', Courier, Monaco, monospace",
                  color: "white",
                  transform:
                    logoAnim == 0
                      ? isMobile
                        ? "translateX(-160px)"
                        : "translateX(-570px)"
                      : isMobile
                      ? "translateX(40px)"
                      : "translateX(60px)",
                  textShadow: "0px 0px 35px blue",
                  transition: "transform 2s",
                }}
              >
                Tech
              </p>
            </div>
          </div>
          {animFinished && loading && (
            <p
              style={{
                fontSize: "23px",
                color: "white",
                textShadow: "0px 0px 5px purple",
              }}
            >
              {texts[userLanguage]["dataBeingLoaded"]}
            </p>
          )}
        </div>
        {userData ? (
          <div
            className="list-item"
            style={{ transform: `translateY(-${y * 100}%)`, zIndex: 5 }}
          >
            <p
              style={{
                fontSize: isMobile ? "30px" : "50px",
                color: "white",
                textShadow: "0px 0px 5px purple",
                textAlign: "center",
              }}
            >
              {texts[userLanguage]["welcomeBack"]}
              {userData.name ? ", " + userData.name : ""}!
            </p>
            {fileUrl && (
              <a href={fileUrl}>
                <Download className="download-icon"></Download>
              </a>
            )}
          </div>
        ) : (
          <div
            className="list-item"
            style={{ transform: `translateY(-${y * 100}%)`, zIndex: 5 }}
          >
            <Register login={() => setY(2)} />
          </div>
        )}

        <div
          className="list-item"
          style={{ transform: `translateY(-${y * 100}%)`, zIndex: 5 }}
        >
          <Login signUp={() => setY(1)} />
        </div>
      </div>
    </>
  );
}

export default Welcome;
